import React, { useEffect, useState } from "react";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-date-fns';
import {
  Container,
  Grid,    
} from '@mui/material';
export default  function LineChart({
    data,
    label,
    fields,   
    chart_options  
  }) {
    const [recievedData, setReceivedData] = useState([]);
    const [recievedLabel, setReceivedLabel] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);    
        const dataValue = [];
        const dataLabel = [];
        data &&
          data.map((element) => {
            element && dataValue.push(parseInt(element[fields[1]]));
            element && dataLabel.push(element[fields[0]]);
            setLoading(false);
          });      
        setReceivedData(dataValue);
        setReceivedLabel(dataLabel);
      }, [data]);

      // const options = {
      //   plugins: {
      //     legend: {
      //       display: false,
      //     },
      //   },
      // //  indexAxis: chart_options.axis,
      //    scales: {
      //     yAxis: {
         
      //         display: false,
                  
      //       ticks: {
      //         beginAtZero:false
      //     },   
      //     },
      //     xAxis: {
       
      //         display:  false 
         
      //     },
      // //       type: 'time',        
      // //       time:{
      // //         unit: 'day'
      //       },
     
      // // adapters: { 
      // //   date: {
      // //     locale: enUS, 
      // //   },
      // // }, 
         
      // //     },
      // //   },

      //       // },
      // };
    

      const options = {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        elements: {
          line: {
            tension: 0.5
          }
      },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              display: false,           
            },
            reverse: chart_options.axisReverse,
            grid: {
             drawBorder: false,
             display: false,
            },
          },
          y: {
          //  maxTicksLimit: 12,
          //    stepSize: 1,           
          //  min: 5,
            ticks: {
            // maxTicksLimit: 12,
           //   steps: 21,
              stepSize: 1
              
          },       
         
            beginAtZero: true,
            grid: {
              drawBorder: false,
              display: false,
            },
          },
        },
      };
      const dataset = {
        yValueFormatString: "$####.00",
        labels: [...recievedLabel],
        datasets: [
          {
            data: [...recievedData],
            backgroundColor: ["rgb(55, 111, 208)"],    
            borderWidth: 1,
            borderColor: "grey",
            hoverOffset: 10,
          },
        ],
        datalabels: {
          align: "end",
          anchor: "start",
        },
      };

      return( 
      <Container>
        <Grid>
        <div>
            <h3>{chart_options.title}</h3>
          </div>
        <Line options={options} data={dataset} />
        </Grid>
     
      </Container>)
     
  }